<template>
  <div :class="[$ps.fullscreen]">
    <fireflies width="100vw" height="100vh" class="fireflies"></fireflies>
    <user-actions></user-actions>
  </div>
</template>

<script>
import Fireflies from '@/components/Fireflies.vue';
import UserActions from '@/components/UserActions.vue';

export default {
  name: 'HomeView',
  components: {Fireflies, UserActions}
}

</script>

<style scoped>

</style>